import { API_endpoints } from "../config";

export const getParentsKidBooking = async (
    kidIds: number[] = [],
    monday?: Date,
    status?: string[],
    is_forward = false,
    apply24HourRule = false   
): Promise<any> => {
    try {
        const body = kidIds.length > 0 ? {
            kidIds,
            monday: monday?.toISOString().split('T')[0],
            status,
            today_date: new Date(),
            is_forward,
            apply24HourRule         
        } : {};

        const response = await fetch(API_endpoints.getParentsKidBooking, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(body),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Laden von kids booking Daten.");
        }

        const data = await response.json();
        return data;

    } catch (error) {
        console.error("Fehler beim Laden von kids booking Daten:", error);
    }
};
